"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.headingCommon = exports.textCommon = void 0;
const styled_components_1 = require("styled-components");
exports.textCommon = (0, styled_components_1.css) `
  margin: 0;
  padding: 0;
  letter-spacing: 0;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
`;
exports.headingCommon = (0, styled_components_1.css) `
  ${exports.textCommon}

  ${({ theme }) => (0, styled_components_1.css) `
    padding-bottom: ${theme.spacing.unit * 2}px;
  `}
`;
//# sourceMappingURL=textCommon.js.map